import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersService } from 'src/app/core/services/filters.service';
import { skip, Subscription } from 'rxjs';
import { SPProductFilterOptions, groupByProducts, solutionParticipationProductFilter, ProductExcelRow, products, PaginationOptions, SpProductOrLocationExportPayload,QueryFilter } from '../types/solution-participation-types';
import { SolutionParticipationService } from 'src/app/features/solution-participation-details/service/solution-participation.service';
import { SpExcelExportService } from 'src/app/features/solution-participation-details/service/sp-excelexport.service';
import { CustomPaginator } from '../sku-groupby-products/CustomPaginatorConfiguration';
import { CustomFilterPipe } from '../pipes/custom-filter.pipe';
import { MatCheckbox } from '@angular/material/checkbox';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';

@Component({
    selector: 'app-sku-groupby-products',
    templateUrl: './sku-groupby-products.component.html',
    styleUrls: ['./sku-groupby-products.component.scss'],
    providers: [
        CustomFilterPipe,
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }
    ],
    standalone: false
})
export class SkuGroupbyProductsComponent implements OnInit, OnDestroy {

  private currencySubscription: Subscription | undefined;
  groupedData!: products;
  groupedDataPaginated: groupByProducts[] = [];

  isLoading: boolean = false;

  groupBy : string | undefined;
  solutionGroupName : string | undefined; //for page title

  @ViewChild(MatPaginator) paginator!: MatPaginator ;
  searchByProductInput = new UntypedFormControl;

  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;


  filteredData: groupByProducts[] = [];
  searchTerm: string = '';

  displayLoaderForFilterData : boolean = true;
  advancedFilterData: solutionParticipationProductFilter[] = [];
  productSelectedAdvancedFilters: SPProductFilterOptions = {
      "accountNumber": [],
      "accountName": [],
      "country": [],
      "state": [],
      "city": [],
      "zipCode": [],
      "productSku": [],
      "brand": []
  };
  filterGroupings: { [id: string]: string[] } = {
    'Account Information Filters': [
      'accountNumber',
      'accountName',
      'country',
      'state',
      'city',
      'zipCode'
    ],
    'Product Level Filters': [
      'productSku',
      'brand'
    ]
  };
  excludeKeys = ['productGroup','productName'];
  toggleAdvancedFilterSelection : boolean = false;
  productAdvancedFiltersSubscription: Subscription| undefined;
  data: any = [];
  exportAll: boolean = false;
  productsCount: number = 0;

  // Define the sort direction objects to store the direction for each column
  sortDirections: { [key: string]: string } = {
    product: 'asc',
    sales: 'desc',
    cases: 'desc'
  };
  sortBy: string = 'sales';
  sortDirection = 'desc';
  excelData: ProductExcelRow[] =[];
  allRowsSelected: boolean = false;
  rowSelection: boolean[] = [];
  byDefaultSelectAllRows:boolean=false;
  isGroupRowChecked:boolean = false;
  selectedAdvancedFilters: { [id: string]: string[] } = {};
  searchFocusStartTime: number | undefined;
  paginationOptions: PaginationOptions = {
    limit: 10,
    page: 1,
    sortBy: "",
    sortOrder: "",
    searchTerm: "",
    tabSelected:''
  };
  productNotFound: boolean = false;
  productExcelExportPayload!: SpProductOrLocationExportPayload;
  selectedProductSKUs: string[] = [];
  notSelectedProductSKUs: string[] = [];
  isDownloadingFile:boolean = false;
  advanceQueryFilters: QueryFilter[] = [];
  currencyCode:string = '';


  constructor(
    private _filterService: FiltersService,
    private _solutionParticipation : SolutionParticipationService,
    private _route: ActivatedRoute,
    private _router : Router,
    private _mixpanelService: MixpanelService,
    private _spExcelexportService: SpExcelExportService,
    private _currencyUomService: CurrencyUomService,
    private _cdr: ChangeDetectorRef,
  ) { }

  async ngOnInit() {
    this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);

    this.productAdvancedFiltersSubscription = this._solutionParticipation.getProductDetailsAdvancedFilters().subscribe(advFilter => this.productSelectedAdvancedFilters = advFilter);
    this.byDefaultSelectAllRows = true;

    this._route.queryParams.subscribe(p => {
      this.groupBy = p['groupBy'];
      this.solutionGroupName = p['solutionGroup'];
      this.isGroupRowChecked = p['isProductChecked'];
      this._solutionParticipation.getSummaryAdvancedFilters().subscribe(filters => {
        this.selectedAdvancedFilters = filters;
      });
    });

    if (this.filters?.period != undefined) {
      if(this.groupBy === undefined || this.solutionGroupName === undefined){
        this._router.navigate(['/solution-participation-details']);
      }

      this.productExcelExportPayload = this._solutionParticipation.getSpProductorLocationExportPayload();
      this.productExcelExportPayload.exportType = 'Product';
      this.productExcelExportPayload.contractModel = this.filters;

      await this.getData(this.productSelectedAdvancedFilters);
      this.getCurrency();
      // Set Advanced Filters
      this.advancedFilterData = await this.getAdvancedFilterData();
      if (this.advancedFilterData == undefined) this.advancedFilterData = [];
      // Filter the filteroptions as per the default filters
      this.advancedFilterData = this.advancedFilterData.filter(item => {
        if (
          (this._solutionParticipation.defaultFiltersForSummaryDetail["brandList"].length === 0 ||
            this._solutionParticipation.defaultFiltersForSummaryDetail["brandList"].includes(item.brand)) &&
          (this._solutionParticipation.defaultFiltersForSummaryDetail["productList"].length === 0 ||
            this._solutionParticipation.defaultFiltersForSummaryDetail["productList"].includes(item.productSku))
        ) {
          return true;
        } else {
          return false;
        }
      });
      this.currencySubscription = this._currencyUomService.selectedCurrency$.pipe(skip(1)).subscribe(async () => {
        this.currencyCode = '';
        this._currencyUomService.setCurrencyLoading(true);
        await this.getData(this.productSelectedAdvancedFilters);

        this._currencyUomService.setCurrencyLoading(false);
        this.getCurrency();
        this._cdr.detectChanges();

      });
      this.displayLoaderForFilterData = false;

    } else {
      alert('Please apply filters before navigating to Solution Participation')
      this._router.navigate(['/filter']);
    }
  }

  async getData(advProductFilters: SPProductFilterOptions) {
    this.isLoading = true;
    this.data = await this._solutionParticipation.getByProductData(this.solutionGroupName, advProductFilters,this.paginationOptions);
    this.isLoading = false;
    //When user searches for a product and no data is found
    //dispaly a message 'Product not found'
    if(this.data.totalCount === 0 && this.searchTerm != ''){
      this.productNotFound = true;
      this.productsCount = 0;
      this.isLoading = false;
      return;
    }

    this.upDateQueryFilter('SOLUTION', this.solutionGroupName ?? '', '=', 'And');

    window.scrollTo(0, 0);

    this.groupedData = this.data;
    this.filteredData = this.data.products;

    this.paginate(0, this.paginator.pageSize);
  }

  async getAdvancedFilterData() {
    return await this._solutionParticipation.getSummaryDetailsAdvFilters();
  }


  ngOnDestroy(): void {
    if (this.filtersSubscription) {
      this.filtersSubscription.unsubscribe();
    }
    //Clear the Query filters.
    this.productExcelExportPayload.queryFilters = [];
    this.selectedProductSKUs = [];
    // Clear Cache for Products
    this._solutionParticipation.clearProductViewCache();
    this.currencySubscription?.unsubscribe();
  }
  getAdvancedFilterChips(): string[] {
    const chips: string[] = [];
    Object.keys(this.selectedAdvancedFilters).forEach(key => {
      this.selectedAdvancedFilters[key].forEach(value => {
        chips.push(value);
      });
    });
    return chips;
  }

  async onPageChange(event : PageEvent){
    await this.updatePageData(event.pageIndex, event.pageSize);
  }

  async updatePageData(pageIndex: number, pageSize: number) {

    this.paginationOptions = {
      ...this.paginationOptions,
      page: pageIndex + 1,
      limit: pageSize
    };

    await this.getData(this.productSelectedAdvancedFilters);

  }

  paginate(pageIndex: number, pageSize: number) {
    this.productsCount = this.groupedData.totalCount;
    let startIndex = pageIndex * pageSize;
    let endIndex = (pageIndex * pageSize) + pageSize;
    this.groupedDataPaginated = this.filteredData.slice(startIndex, endIndex);
    if (this.groupedDataPaginated.length > 0 && this.byDefaultSelectAllRows){
      this.byDefaultSelectAllRows = false;
      this.selectAllRows();
    }
  }

  async onSearchInputChange() {
    if(this.searchTerm.length < 3){
      if(!this.searchTerm) {
        await this.clear();
      }

      this.productNotFound = (this.groupedDataPaginated.length === 0);
      return;
    }

    this.paginationOptions = {
      ...this.paginationOptions,
      searchTerm: this.searchTerm,
    };
    await this.getData(this.productSelectedAdvancedFilters);
    if(this.productNotFound)
      return;

    this.paginator.firstPage();
    this.paginate(0, this.paginator.pageSize);
  }

  searchProduct() {
    if(this.searchTerm.length < 3) {
      window.alert("Enter at least 3 characters in order to search.")
      return;
    }
  }

  async clear(){
    (<HTMLInputElement>document.querySelector("#userInput")).value = "";
    this.searchTerm = '';
    // Reset paginationOptions to initial values
    this.paginationOptions = {
      limit: 10,
      page: 1,
      sortBy: '',
      sortOrder: '',
      searchTerm: '',
      tabSelected: ''
    };
    this.productNotFound = false;
    this.productExcelExportPayload.queryFilters = [];
    await this.getData(this.productSelectedAdvancedFilters);
  }


  productDrillClicked(product: groupByProducts, event: Event, rowNumber:any) {
    if(product.totalAccountCount == 0 || product.totalAccountCount == 1) return;
    if(!(event.target as HTMLElement).closest('.mat-checkbox-inner-container')) {
      let selectedProductName = product?.productName;
      let selectedProductCode = product?.productCode;
      this._router.navigate(['/solution-participation-product-drilldown'], {
        queryParams: {
          solutionGroup: this.solutionGroupName,
          productCode: selectedProductCode,
          productName: selectedProductName,
          isProductChecked:this.rowSelection[rowNumber]
        }
      });

      this._mixpanelService.track('Product Details Summary Row Clicked', {
          'Product Name': selectedProductName,
          'Page Name': 'Solution Participation - Product Details'
      });
    }

  }

  async toggleSortDirection(column: string) {
    // Toggle the sort direction for the specified column
    this.sortDirections[column] = this.sortDirections[column] === 'asc' ? 'desc' : 'asc';
    this.sortBy = column;
    this.sortDirection = this.sortDirections[column];

    this.paginationOptions = {
      ...this.paginationOptions,
      sortBy: this.getSortedColumnName(this.sortBy),
      sortOrder: this.sortDirection,
    };
    await this.getData(this.productSelectedAdvancedFilters);

    this._mixpanelService.track('Product Details - Header Sort Icon Clicked', {
      'Column Name': column,
      'Page Name': 'Solution Participation - Product Details',
    });

  }

  onSearchFocus() {
    // Record the start time when the user focuses on the search field
    this.searchFocusStartTime = Date.now();
  }

  onSearchBlur() {
    const blurDurationInMilliseconds = Date.now() - this.searchFocusStartTime!; // Calculate the duration in milliseconds
    const blurDurationInSeconds = (blurDurationInMilliseconds / 1000).toFixed(1) + "sec";
    this._mixpanelService.track('Product Details - Search Box Engagement Duration', {
      'Page Name': 'Solution Participation - Product Details',
      'Duration': blurDurationInSeconds
    });
  }


  onCheckboxChange(event: MatCheckbox, row: any, rowNumber: number): void {
    const pageSize = this.paginator.pageSize;
    const pageIndex = this.paginator.pageIndex;
    rowNumber = (pageSize * pageIndex) + rowNumber;
    this.rowSelection[rowNumber] = event.checked;
    // If the row is selected, add it to the selectedProductSKUs
    const selectedSet = new Set(this.selectedProductSKUs);
    // If the row is not selected, add it to the notSelectedProductSKUs
    const notSelectedSet = new Set(this.notSelectedProductSKUs);
    if (event.checked) {
        selectedSet.add(row.productCode);
        notSelectedSet.delete(row.productCode);
    } else {
        selectedSet.delete(row.productCode);
        notSelectedSet.add(row.productCode);
    }

    this.selectedProductSKUs = Array.from(selectedSet);
    this.notSelectedProductSKUs = Array.from(notSelectedSet);
    this.allRowsSelected = this.isAllSelected();
  }

  // This Method is to check the check box.
  selectAllRows() {
    this.allRowsSelected = !this.allRowsSelected;
    for (let i = 0; i < this.groupedData.totalCount; i++) {
      let number = (this.paginator.pageIndex * this.paginator.pageSize)+i;
      this.rowSelection[number] = this.allRowsSelected;
    }
    this.notSelectedProductSKUs = this.selectedProductSKUs = [];
    this.allRowsSelected = this.isAllSelected();
  }

  isAllSelected() {
     return !this.rowSelection.some(value => value === false);
  }


  async exportAllToExcel(){
    if(!this.rowSelection.includes(true)){
      window.alert('Please select at least one product to export.');
      return;
    }
    if (this.advanceQueryFilters.length > 0) {
      this.productExcelExportPayload.queryFilters?.push(...this.advanceQueryFilters);
    } else {
      if(!this.isAllSelected())
          this.applyProductSKUFiltersForExport();
    }
    // Set the search term in the payload
    this.productExcelExportPayload.searchTerm = this.searchTerm;


    this.isDownloadingFile = true;
     const currentDate = new Date().toISOString().slice(0, 19).replace(/[-T:/]/g, '');
     const fileName = `EBR__Product_Details_${currentDate}_Solution.xlsx`;

     let initializeDownload = true;
     const fileData = await this._solutionParticipation.DownloadExcel(this.productExcelExportPayload).then(response => {
      if (response) {
         const { data } = response;
         return data;
       }
       initializeDownload = false;
       return null;
     }).catch(error => {
      initializeDownload = false;
      this.isDownloadingFile = false;
       console.log(JSON.stringify(error));
     });

      if (initializeDownload && fileData.size > 0) {
        this._spExcelexportService.executeBrowserDownload(fileData,fileName);

        this._mixpanelService.track('Solution Participation - Product Details - Export Button Clicked', {
          'No Of Records Downloaded and FileName': `${fileData.size} and ${fileName}`,
          'Page Name': 'Solution Participation - Product Details',
        });
      }else{
        alert('No data found to export.');
      }
      this.isDownloadingFile = false;

      // Clear the selected product SKUs after export.
      this.productExcelExportPayload.queryFilters = this.productExcelExportPayload.queryFilters?.filter(filter =>
        !filter.columnFilters.hasOwnProperty('PRODUCTCODE')
      );
      // Clear the Search Term
      this.productExcelExportPayload.searchTerm = '';
  }



  async onSelectedFiltersChange(selectedFilters:{ [id: string]: string[] }) {
    this._solutionParticipation.setProductDetailsAdvancedFilters(selectedFilters as SPProductFilterOptions);
    this.advanceQueryFilters = this.updatAdvanceFilters(selectedFilters as SPProductFilterOptions);
    if (this.filters?.period != undefined) {
      this.clearExcelOptions();
      await this.getData(this.productSelectedAdvancedFilters);
      if(this.searchTerm.length >= 3) {
        this.onSearchInputChange();
      }
    }
  }

  clearExcelOptions(){
    this.rowSelection = [];
    this.allRowsSelected = false;
    this.byDefaultSelectAllRows = true;
  }

  getCurrency() {
    this.currencyCode = this._currencyUomService.getCurrencyCode();
  }

  /// This method returns the column name based on the sortColumn parameter
  /// It is used to map the sort column to the actual data field name in BE Database.
  getSortedColumnName(sortColumn:string): string {
    switch (sortColumn) {
      case 'sales':
        return 'TotalSalesAmount';
      case 'cases':
        return 'TotalSalesQuantity';
      default:
        return 'TotalSalesQuantity';
    }
  }

  applyProductSKUFiltersForExport() {
    if ((this.selectedProductSKUs.length > 0)) {
      this.upDateQueryFilter('PRODUCTCODE', this.selectedProductSKUs, 'In','And');

    } else if (this.notSelectedProductSKUs.length > 0) {
      this.upDateQueryFilter('PRODUCTCODE', this.notSelectedProductSKUs, 'Not In','And');
    }
    return [];
  }


  upDateQueryFilter(
    columnName: string,
    filterValue: any,
    filterOperation: "In" | "Not In" | "Equals" | "ILike" | "=" | "!=",
    logicalOperator: "And" | "Or"
  ) {
    this._spExcelexportService.upsertQueryFilter(
      this.productExcelExportPayload,
      columnName,
      filterValue,
      filterOperation,
      logicalOperator);
  }

  updatAdvanceFilters(selectedFilters: SPProductFilterOptions): QueryFilter[] {
    return this._spExcelexportService.upsertAdvanceFilters(selectedFilters, this.productExcelExportPayload);
  }
}
